import React from 'react';

type Props = {
  imgSrc: string;
  title: string;
  description: string;
};

export const Block = ({ imgSrc, title, description }: Props) => {
  return (
    <div className="flex flex-col items-center gap-8">
      <div>
        <img src={imgSrc} alt="" />
      </div>
      <h3 className="text-content-primary title-l">{title}</h3>
      <p className="text-center text-content-primary body-m">{description}</p>
    </div>
  );
};
